export default "__VITE_ASSET__CuHPnjX4__"